/**
 * Utility functions for handling input events and focus states
 */

/**
 * Checks if a text input field (input, textarea, etc.) is currently focused
 * This helps prevent game keyboard shortcuts from interfering with text input
 */
export function isTextInputFocused(): boolean {
  let activeElement = document.activeElement;
  // A field inside a shadow root (the feedback form is one) leaves the shadow
  // host as document.activeElement; follow it down to the field itself.
  while (activeElement?.shadowRoot?.activeElement) activeElement = activeElement.shadowRoot.activeElement;
  if (!activeElement) return false;
  
  if (activeElement instanceof HTMLTextAreaElement) return true;
  if (!(activeElement instanceof HTMLInputElement)) return false;

  const inputType = activeElement.type.toLowerCase();
  return inputType === 'text' || inputType === 'email' || inputType === 'password';
}